import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { getStrategiesByType } from '@/utils/recommendation-strategies';
import { ExternalStrategyType } from '@/features/strategies/types';

export const USER_ID_MANDATORY_TYPES = new Set<RecommendationType>([
  RecommendationType.PAST_PURCHASES,
  RecommendationType.PERSONALIZED,
  RecommendationType.PURCHASED_WITH_RECENTLY_PURCHASED,
]);

// TODO: Define dedicated strategy lists for RECS and UPSELLS once those flows
// are supported (only EMBED's list is defined for now).
const EMBED_STRATEGIES = getStrategiesByType([
  RecommendationType.MOST_POPULAR,
  RecommendationType.NEW_ARRIVALS,
  RecommendationType.MANUAL,
  RecommendationType.PAST_PURCHASES,
  RecommendationType.PERSONALIZED,
  RecommendationType.PURCHASED_WITH_RECENTLY_PURCHASED,
]);

export function filterStrategiesForExternalType(
  externalType: ExternalStrategyType,
) {
  switch (externalType) {
    case ExternalStrategyType.EMBED:
      return EMBED_STRATEGIES;
    default:
      return EMBED_STRATEGIES;
  }
}
